import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { PatentChange } from 'src/types/api/patentRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: PatentChange;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利改請案 區塊。
 */
const InfoPatentChange: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  return (
    <DropdownInfo title={`專利改請案`} isShow={isShow} setIsShow={setIsShow} color={angleColor}>
      <Table color={tableColor}>
        <Item>
          <Title>原申請案號</Title>
          <Content>{data.applyNo || noContent}</Content>
          <Title>專利類別</Title>
          <Content>{data.applyClass || noContent}</Content>
        </Item>
        <Item>
          <Title>改請後申請案號</Title>
          <Content>{data.newApplyNo || noContent}</Content>
          <Title>相關申請案類別</Title>
          <Content>{data.newApplyClass || noContent}</Content>
        </Item>
      </Table>
    </DropdownInfo>
  );
};

export default InfoPatentChange;
